module.exports = __webpack_public_path__ + "img/top.8821ec1c.png";